<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :loading="buttonLoading"
                color="success"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>cloud_download</v-icon>
                Export</v-btn
              >
            </template>

            <v-list>
              <v-list-tile @click="printAllMenu('printMenu')">
                <v-list-tile-content>
                  <v-list-tile-title>PRINT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="exportAllMenu()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-layout row wrap>
          <v-flex sm3>
            <v-menu
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="queryParams.fromDate"
                label="From Date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex sm3>
            <v-menu
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="queryParams.toDate"
                label="To Date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="queryParams.toDate"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex sm3>
            <v-text-field
              name="saleNo"
              label="Product Name"
              v-model="queryParams.menuName"
              type="text"
            ></v-text-field>
          </v-flex>
          <v-flex sm3>
            <v-text-field
              name="productCode"
              label="Code"
              v-model="queryParams.productCode"
              type="text"
            ></v-text-field>
          </v-flex>
          <v-flex sm3>
            <v-select
              :items="shopList"
              label="Choose Shop..."
              item-text="name"
              menu-props="auto"
              item-value="id"
              :readonly="user.role.roleName == 'BRANCH_ADMIN'"
              v-model="queryParams.shopId"
            ></v-select>
          </v-flex>
          <v-flex sm3>
            <v-select
              :items="categoryList"
              label="Choose Category..."
              item-text="name"
              menu-props="auto"
              item-value="id"
              v-model="queryParams.categoryId"
              type="text"
            ></v-select>
          </v-flex>
          <v-flex sm3>
            <v-select
              :items="brandList"
              label="Choose Brand..."
              item-text="name"
              menu-props="auto"
              item-value="id"
              v-model="queryParams.brandId"
            ></v-select>
          </v-flex>
          <v-flex sm3>
            <v-select
              :items="productGroupList"
              label="Choose Product Group..."
              item-text="name"
              menu-props="auto"
              item-value="id"
              v-model="queryParams.productGroupId"
            ></v-select>
          </v-flex>
           <v-flex sm3>
            <v-select
              :items="saleTypeList"
              label="Choose Sale Type..."
              v-model="queryParams.saleType"
              item-text="label"
              item-value="value"
            ></v-select>
          </v-flex>
          <v-flex sm3>
            <v-btn outline color="primary" @click="onSearch">
              Search
              <v-icon right>search</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex d-flex xs12>
        <v-card>
          <v-card-title class="blue darken-3">
            <span class="headline white--text">Summary</span>
            <v-spacer></v-spacer>
            <v-icon @click="show = !show" class="white--text">{{
              show ? "keyboard_arrow_up" : "keyboard_arrow_down"
            }}</v-icon>
          </v-card-title>
          <v-card-text class="font-weight-bold" v-show="show">
            <div>
              <span>Total Retail Sale Amount:</span>
              <v-chip>
                <span>{{ totalRetailSaleAmount | decFormat(6)}}</span>
              </v-chip>

              <span>Total Retail Sale FOC Amount:</span>
              <v-chip>
                <span>{{ totalRetailSaleFocAmount | decFormat(6)}}</span>
              </v-chip>
            </div>
            <div>
              <span>Total Sale Amount:</span>
              <v-chip>
                <span>{{ totalWholeSaleAmount | decFormat(6)}}</span>
              </v-chip>

              <span>Total Sale FOC Amount:</span>
              <v-chip>
                <span>{{ totalWholeSaleFocAmount | decFormat(6)}}</span>
              </v-chip>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :must-sort="true"
            :headers="headers"
            :items="menuReportList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.shopName }}</td>
              <td>{{ props.item.saleType }}</td>
              <td>{{ props.item.productName }}</td>
              <td>{{ props.item.productCode }}/{{ props.item.brandName }}/{{ props.item.categoryName }}/{{ props.item.productGroupName }}</td>
              <td>{{ props.item.factorUnitName }}</td>
              <td style="text-align: right">{{ props.item.unitPrice | decFormat(6) }}</td>
              <td style="text-align: right">{{ props.item.focQty | decFormat(6) }}</td>
              <td style="text-align: right">{{ props.item.focAmount | decFormat(6) }}</td>
              <td style="text-align: right">{{ props.item.saleQty | decFormat(6) }}</td>
              <td style="text-align: right">{{ props.item.saleAmount | decFormat(6) }}</td>
              <td style="text-align: right">{{ props.item.saleAmount + props.item.focAmount | decFormat(6) }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- <summary report> -->
    <div id="printMenu" style="bsale:1px solid black;width:300px;" v-show="false">
      <div style="text-align:center">
        <p style="font-size:18px;margin:1px">Product Item Summary</p>
      </div>
      <div style="text-align:center">
        <p
          style="font-size:15px;margin:1px"
        >From: [{{queryParams.fromDate}}] To: [{{queryParams.toDate}}]</p>
      </div>
      <div style="text-align:left">
        <p
          style="font-size:15px;margin:0px"
        >Total Retail Sale Amount: {{ totalRetailSaleAmount | decFormat(6)}}</p>
      </div>
      <div style="text-align:left">
        <p
          style="font-size:15px;margin:0px"
        >Total Retail Sale FOC Amount: {{ totalRetailSaleFocAmount  | decFormat(6)}}</p>
      </div>
      <div style="text-align:left">
        <p
          style="font-size:15px;margin:0px"
        >Total Sale Amount: {{ totalWholeSaleAmount  | decFormat(6)}}</p>
      </div>
      <div style="text-align:left">
        <p
          style="font-size:15px;margin:0px"
        >Total Sale FOC Amount: {{ totalWholeSaleFocAmount | decFormat(6)}}</p>
      </div>
      <br />
      <div style="padding-left:5px;padding-right:5px">
        <table
          style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;border-top:1px solid black"
        >
          <thead style="border-bottom:1px solid black;border-top:1px solid black">
            <tr>
              <th style="text-align:left">Shop Name</th>
              <th style="text-align:left">Sale Type</th>
              <th style="text-align:left">Product Name</th>
              <th style="text-align:left">Code/Brand/Category/Group</th>
              <th style="text-align:left">Unit</th>
              <th style="text-align:left">Price</th>
              <th style="text-align:left">FOC</th>
              <th style="text-align:left">FOC Amt</th>
              <th style="text-align:left">Sale</th>
              <th style="text-align:left">Sale Amt</th>
              <th style="text-align:left">Total Amt</th>
            </tr>
          </thead>
          <tbody>
             <tr v-for="(item, index) in allMenuReportList" :key="index">
              <td style="text-align:left">{{item.shopName}}</td>
              <td style="text-align:left">{{item.saleType}}</td>
              <td style="text-align:left">{{item.productName}}</td>
              <td style="text-align:left">{{item.productCode}}/{{item.brandName}}/{{item.categoryName}}/{{item.productGroupName}}</td>
              <td style="text-align:left">{{item.factorUnitName}}</td>
              <td style="text-align:right">{{item.unitPrice | decFormat(6)}}</td>
              <td style="text-align:right">{{item.focQty | decFormat(6) }}</td>
              <td style="text-align:right">{{item.focAmount | decFormat(6) }}</td>
              <td style="text-align:right">{{item.saleQty | decFormat(6) }}</td>
              <td style="text-align:right">{{item.saleAmount | decFormat(6) }}</td>
              <td style="text-align:right">{{item.saleAmount + item.focAmount | decFormat(6) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </v-container>
</template>

<script>
import { commonService } from "../../services/common-service";
import { menuReportService } from "../../services/menu-report-service";
import { shopService } from "../../services/shop-service";
import { categoryService } from "../../services/category-service";
import { brandService } from "../../services/brand-service";
import { productGroupService } from "../../services/product-group-service";

export default {
  name: "MenuReportList",

  components: {},
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    printAllLoading: false,
    showFilters: false,
    show: false,
    shopList: [],
    categoryList: [],
    brandList: [],
    productGroupList: [],
    allMenuReportList: [],
    breadcrumbs: [
      {
        text: "Reports",
        disabled: true
      },
      {
        text: "General Reports",
        disabled: true
      },
      {
        text: "Product Sale Report",
        disabled: true
      }
    ],
    headers: [
      { text: "Shop Name", align: "left", value: "t.shopName" },
      { text: "Sale Type", align: "left", sortable: false },
      { text: "Product Name", align: "left", value: "t.productName" },
      { text: "Code/Brand/Category/Group", align: "left", sortable: false},
      { text: "Unit", align: "left", sortable: false },
      { text: "Price", value: "t.unitPrice" },
      { text: "FOC", sortable: false },
      { text: "FOC Amt", sortable: false },
      { text: "Sale", sortable: false },
      { text: "Sale Amt", sortable: false },
      { text: "Total Amt", sortable: false }
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: false,
      page: 1,
      rowsPerPage: 50,
      sortBy: "",
      totalItems: 0
    },
    menuReportList: [],
    totalRows: 0,
    decimalFormat: "",
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      menuName: "",
      categoryId: "",
      shopId: "",
      productCode: "",
      brandId: "",
      productGroupId: "",
      saleType: "",
      updateUserId: "",
    },
    saleTypeList: [
      { label: "---All---", value: "" },
      { label: "Retail Sale", value: "RETAIL SALE" },
      { label: "Sale", value: "WHOLE SALE" }
    ],
    clonequeryParams: new Object(),
    buttonLoading: false,
    totalRetailSaleAmount: 0,
    totalRetailSaleFocAmount: 0,
    totalWholeSaleAmount: 0,
    totalWholeSaleFocAmount: 0
  }),
  watch: {
    pagination: {
      handler() {
        this.getMenuReportList();
        this.getMenuReportSummary();
      },
      deep: true
    }
  },
  created() {
    if (this.user.role.roleName == "SALE_MANAGER") {
      this.queryParams.updateUserId = this.user.id;
    }
    if (this.user.role.roleName == "BRANCH_ADMIN") {
      this.queryParams.shopId = this.user.shopId;
    }
    //for deep linking
    if (this.$route.query.shopId) {
      this.queryParams.shopId = this.$route.query.shopId;
    }
    if (this.$route.query.categoryId) {
      this.queryParams.categoryId = this.$route.query.categoryId;
    }
    if (this.$route.query.menuName) {
      this.queryParams.menuName = this.$route.query.menuName;
    }
    if (this.$route.query.productCode) {
      this.queryParams.productCode = this.$route.query.productCode;
    }
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }

    if (this.$route.query.brandId) {
      this.queryParams.brandId = this.$route.query.brandId;
    }

    if (this.$route.query.productGroupId) {
      this.queryParams.productGroupId = this.$route.query.productGroupId;
    }

    if (this.$route.query.updateUserId) {
      this.queryParams.updateUserId = this.$route.query.updateUserId;
    }

    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.getAllShop();
    this.getAllCategory();
    this.getAllBrand();
    this.getAllProductGroup();
    this.decimalFormat = commonService.formatdecimal();
    this.onSearch();
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({ name: "menu-report", query: this.queryParams });
      this.getMenuReportList();
      this.getMenuReportSummary();
      this.clonequeryParams = Object.assign({}, this.queryParams);
    },

    getAllShop() {
      shopService
        .getAllShop()
        .then(res => {
          this.shopList = res.data;
          let findAll = {
            id: "",
            name: "----All----"
          };
          this.shopList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch(err => {
          console.log(err);
        });
    },

    getAllCategory() {
      categoryService
        .getAllCategory()
        .then(res => {
          this.categoryList = res.data;
          let findAll = {
            id: "",
            name: "----All----"
          };
          this.categoryList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch(err => {
          console.log(err);
        });
    },

    getAllBrand() {
      brandService
        .getAllBrand()
        .then(res => {
          this.brandList = res.data;
          let findAll = {
            id: "",
            name: "---All---"
          };
          this.brandList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch(err => console.log(err));
    },

    getAllProductGroup() {
      productGroupService
        .getAllProductGroup()
        .then(res => {
          this.productGroupList = res.data;
          let findAll = {
            id: "",
            name: "---All---"
          };
          this.productGroupList.splice(
            0,
            0,
            JSON.parse(JSON.stringify(findAll))
          );
        })
        .catch(err => console.log(err));
    },
    getMenuReportSummary() {
      menuReportService
        .getMenuReportSummary(this.queryParams)
        .then(res => {
          if (res.data) {
            this.totalRetailSaleAmount = res.data.totalRetailSaleAmount;
            this.totalRetailSaleFocAmount = res.data.totalRetailSaleFocAmount;
            this.totalWholeSaleAmount = res.data.totalWholeSaleAmount;
            this.totalWholeSaleFocAmount = res.data.totalWholeSaleFocAmount;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getMenuReportList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      menuReportService
        .getMenuReportList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then(res => {
          if (res.data) {
            this.menuReportList = res.data.menuReportList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    exportAllMenu() {
      this.printAllLoading = true;
      menuReportService
        .exportMenuReportExcel(this.queryParams)
        .then(res => {
          commonService.downloadE(res);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.printAllLoading = false;
        });
    },
    printAllMenu(divName) {
      this.buttonLoading = true;
      menuReportService
        .getAllMenuReportList(this.clonequeryParams)
        .then(res => {
          if (res.data) {
            this.allMenuReportList = res.data.menuReportList;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.buttonLoading = false;
        });
    },
    clear() {
      this.queryParams.data = commonService.formatDate(
        new Date(),
        "YYYY-MM-DD"
      );
    }
  }
};
</script>
